import React, { useState } from 'react';
import { Navbar, Image, Badge, div, ListGroup } from 'react-bootstrap';

function MyApp(props) {


 
  return (
    <div class={props.Course_Syllabus.length > 0 ? "visible" : 'invisible'}>
      <ListGroup >
      <ListGroup.Item >סילבוסים </ListGroup.Item>
       {props.Course_Syllabus.map((item,i) => (
           <ListGroup.Item ><a href={item.Syllabus_link} target="_blank" >{item.coursename}</a>   </ListGroup.Item>
       ))}

   </ListGroup>

    </div>
  );
}
export default MyApp;